/**
 * The copy the usage-impact step pairs each of the user's most-used features with, keyed by
 * the feature keys `GET /api/subscriptions/usage-summary` returns (EN-881's
 * SubscriptionUsageSummaryService constants — a different vocabulary from the cancellation
 * reasons in ./reasons.js, which is why this table lives on its own).
 *
 * Titles and descriptions are the spec's copy table verbatim, except the AutoApply title, which
 * EN-1313 changed when paid AutoApply became unlimited. The Free-plan numbers quoted here
 * are the ones the pricing page advertises, which for a few features are not the ones
 * UserFeatureUsage::FREE_PLAN_FEATURES actually enforces — that drift predates this screen and
 * reconciling it is not this screen's job.
 *
 * `description` takes the count the endpoint reported, and for recommendations the category it
 * came from. Learning Hub is the filler the endpoint appends when the user has fewer than three
 * features with any usage, so its copy ignores both — course access has nothing to count.
 */
export const USAGE_FEATURE_COPY = {
	auto_apply: {
		title: 'Unlimited AutoApply uses',
		description: (count) => `Only 5 on the Free plan. You’ve used it ${count} this month.`,
	},
	cover_letters: {
		title: 'Unlimited cover letters',
		description: (count) => `Only 3 on the Free plan. You’ve generated ${count} this month.`,
	},
	networking: {
		title: 'Unlimited networking',
		description: (count) => `Only 1 message on the Free plan. You’ve sent ${count} this month.`,
	},
	bullet_points: {
		title: 'Unlimited AI bullet points',
		description: (count) => `Only 5 on the Free plan. You’ve generated ${count} this month.`,
	},
	interview_ai: {
		title: 'Unlimited InterviewAI',
		description: (count) => `Only 1 session on the Free plan. You’ve completed ${count} this month.`,
	},
	recommendations: {
		title: 'Unlimited recommendations',
		description: (count, category) => `The Free plan reveals 2 per category. You’ve used ${count} of 2 in ${category}.`,
	},

	// These two are counted lifetime rather than per month, so their copy says so.
	tracked_applications: {
		title: 'Unlimited tracking',
		description: (count) => `Only 30 on the Free plan. You’re tracking ${count} right now.`,
	},
	resume_uploads: {
		title: 'Unlimited uploads',
		description: (count) => `Only 1 on the Free plan. You’ve uploaded ${count}.`,
	},

	learning_hub: {
		title: 'Unlimited course access',
		description: () => 'Access is limited on the Free plan.',
	},
};
